export default "__VITE_ASSET__5qhVntYR__"